import { render } from "./CopyToClipboard.vue?vue&type=template&id=b235b89e&scoped=true&ts=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=b235b89e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b235b89e"]])

export default __exports__